class Video {
    constructor() {

        const placeHolders = document.querySelectorAll('.place-holder-video');
        if ( placeHolders.length > 0 ) {
            // look for dom strings w/ .place-holder-video and convert the string to
            // appropriate HTML before attempting to process .js-video-player
            placeHolders.forEach(function(placeHolder, idx) {
                const videoString   = placeHolder.dataset.video.split('').reverse().join('');
                const videoHtml     = Buffer.from(videoString, 'base64').toString('utf8');
                const parser        = new DOMParser();
                const html          = parser.parseFromString(videoHtml, 'text/html');
                const figures       = html.getElementsByTagName('figure');
                if ( figures.length > 0 ) {
                    placeHolder.replaceWith( figures[0] );
                }
            });
        }

        this.instances = document.querySelectorAll('.js-video-player');

        this.videosStatus = null;
    }

    init(helpers) {
        const self = this;

        this.helpers = helpers;

        self.enhanceAll(self);
    }

    enhance(instance, self) {
        let fallbackLink,
            loaderHtml,
            loadButton,
            loadButtonHtml,
            thumbnail,
            videoTitle;

        fallbackLink = instance.querySelector('.fallback-link');

        if (!fallbackLink) return;

        videoTitle = instance.querySelector('.title');

        thumbnail = instance.querySelector('img.thumbnail');

        if (thumbnail) {
            thumbnail = thumbnail.cloneNode(true);
        }

        fallbackLink.parentElement.removeChild(fallbackLink);

        if (!thumbnail) {
            self.loadVideo(instance);
        } else {
            let iframe;
            const membershipRequired    = jQuery('body').hasClass('membership-is-required') ? true : false;
            const isAMember             = jQuery('body').hasClass('ehrc-member') ? true : false;
            const video_label           = ( membershipRequired && !isAMember )
                                        ? i18n['video']['login_and_play']
                                        : i18n['video']['load_and_play'];
            const tag                   = ( membershipRequired && !isAMember ) ? 'span' : 'button'; // span: prevents you to from viewing the video

            loaderHtml = `
            <p class="loader">
                <${tag}
                    type="button"
                    aria-describedby="${videoTitle.id}"
                    class="button"
                >
                    <br aria-hidden="true">

                    <span class="text">
                        <span class="action">${video_label}</span>
                    </span>
                </${tag}>
            </p>
            `;

            videoTitle.insertAdjacentHTML('afterend', loaderHtml);

            loadButton = instance.querySelector('.loader > .button');

            loadButton.insertAdjacentElement('afterbegin', thumbnail);

            instance.dataset.videoStatus = 'awaiting-click';

            loadButton.addEventListener('click', function(e) {
                self.loadAndPlayVideo(e, self);
            });
        }

        instance.dataset.js = 'on';
    }

    enhanceAll(self) {
        for (let instance of self.instances) {
            instance = self.enhance(instance, self);
        }
    }

    loadVideo(instance) {
        let iframe;

        iframe = instance.querySelector('iframe.js-video-player');

        if (!iframe) return;

        iframe.src = iframe.dataset.src;
        iframe.removeAttribute('data-src');
        iframe.hidden = false;

        instance.dataset.videoStatus = 'loaded';
    }

    loadAndPlayVideo(e, self) {
        if ('BUTTON' !== e.currentTarget.tagName) return;

        let button = e.currentTarget,
            br = button.querySelector('br'),
            iframe,
            iframeDataSrc,
            instance = button.closest('.js-video-player'),
            thumbnail = button.querySelector('img');

        iframe = instance.querySelector('iframe.js-video-player');

        iframeDataSrc = new URL(iframe.dataset.src);

        iframeDataSrc.searchParams.set('rel', '0');
        iframeDataSrc.searchParams.set('autoplay', '1');
        iframeDataSrc.searchParams.set('modestbranding', '1');

        iframe.dataset.src = iframeDataSrc;

        self.loadVideo(instance);
        button.disabled = true;
    }
    hasClass(element, className) {
        return (' ' + element.className + ' ').indexOf(' ' + className+ ' ') > -1;
    }

}// end Class

// Singleton
export default Video;